module.exports = __webpack_public_path__ + "img/recommend-1-h5.da1784d0.png";